import { action } from '@ember/object';
import Component from '@glimmer/component';

import $ from 'jquery';

import didInsert from 'webapp/modifiers/did-insert';
import didUpdate from 'webapp/modifiers/did-update';
import BarLoaderComponent from 'webapp/components/bar-loader';

interface Args {
	isActive: boolean | undefined;
}

export default class BarLoaderOverlayComponent extends Component<Args> {
	@action
	addClassToContainer(node: HTMLElement) {
		const el = $(node);

		const width = el.parent().width() || 0;

		el.css({ width }).parent().toggleClass('barloaderOverlay', this.args.isActive);
	}
	<template>
		<div
			class="barloaderOverlayContainer {{if @isActive 'visible'}}"
			{{didInsert this.addClassToContainer}}
			{{didUpdate this.addClassToContainer @isActive}}
		>
			<BarLoaderComponent @size="big" />
		</div>
	</template>
}
